import './utils/wallet/browserPolyfills'
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// import { dologin } from './utils/useWeb3Modal';

import { initializeWalletRuntime } from './utils/wallet/walletRuntime'
// Default to BNB Smart Chain / USDT when the visitor has no valid preference.
// Some Android WebViews can deny localStorage; that must not stop Vue mounting.
try {
  const storedChainId = Number(localStorage.getItem('cur_chainId'));
  if (![1, 56].includes(storedChainId)) {
    localStorage.setItem('cur_chainId', '56');
  }
  const storedCoin = (localStorage.getItem('sys_coin') || '').toLowerCase();
  if (!['usdt', 'usdc'].includes(storedCoin)) {
    localStorage.setItem('sys_coin', 'usdt');
  }
} catch (error) {
  // The page remains available even when storage is disabled by the browser.
}

import Clipboard from "v-clipboard";
import {
	Overlay,Uploader,Button,DropdownMenu, DropdownItem,
	Tab, Tabs, Empty,
	TextEllipsis,
	Notify,
	ShareSheet,
	closeToast,
	showLoadingToast,
	RollingText,
	Toast,
	Dialog,
	NoticeBar,
	Swipe,
	SwipeItem,
	Icon,
	Progress,
	Field,
	Collapse, CollapseItem,
	Cell,
	RadioGroup,
	Radio,
	PasswordInput,
	NumberKeyboard,
	Popup,
	CellGroup,
	ActionSheet,
	CountDown, Checkbox,
	Loading
} from "vant";
import 'vant/lib/index.css';

// import vueTouch from "vue-plugin-touch";
import touch from 'vue-directive-touch';
import i18n from './i18n';
import { formatBrowserTime } from './utils/dateTime';
import '@/assets/styles/reset.scss';
import 'lib-flexible';

const app = createApp(App);
app.config.compilerOptions.isCustomElement = (tag) => {
  return tag === 'appkit-button';
};
app.use(router)
	.use(Toast)
	.use(Overlay)
	.use(Uploader)
	.use(RadioGroup)
	.use(Radio)
	.use(Button)
	.use(DropdownMenu)
	.use(DropdownItem)
	.use(Tab)
	.use(Tabs)
	.use(Empty)
	.use(CountDown)
	.use(Checkbox)
	.use(store)
	.use(i18n)
	.use(ShareSheet)
	.use(closeToast)
	.use(showLoadingToast)
	.use(Clipboard)
	.use(RollingText)
	.use(TextEllipsis)
	.use(Notify)
	.use(Dialog)
	// .use(vueTouch)
	.use(touch)
	.use(Icon)
	.use(Progress)
	.use(Field)
	.use(NoticeBar)
	.use(Swipe)
	.use(PasswordInput)
	.use(NumberKeyboard)
	.use(Popup)
	.use(Loading)
	.use(ActionSheet)
	.use(Collapse)
	.use(CollapseItem)
	.use(Cell).use(CellGroup)
	.use(SwipeItem);


app.config.globalProperties.utils_moneyMark = function () {
	var coin = localStorage.getItem("sys_coin");
	if(coin && coin=='usdt'){
		return "USDT";
	}else{
		return "USDC";
	}
};
app.config.globalProperties.formatBrowserTime = formatBrowserTime;
app.config.globalProperties.showcover = false;

app.mount('#app');

// Wallet SDKs are loaded after Vue has rendered the application. A browser
// compatibility error in a third-party wallet package must not blank the site.
void initializeWalletRuntime()
